import apiClient from '../apiClient';
import { GET_REGION_BY_COUNTRY_URL } from '../apiUrl';

const getRegionByCountryApi = Id => {
  return apiClient.get(GET_REGION_BY_COUNTRY_URL(Id));
};

export default getRegionByCountryApi;
